import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=80f3cb00&scoped=true&"
var script = {}
import style0 from "./Newspaper.vue?vue&type=style&index=0&id=80f3cb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f3cb00",
  null
  
)

export default component.exports